const rgbaToHex = valueArr => {
    // rgba max values are (255, 255, 255, 1)
    // Given the alpha channel is 0-1 we need to multiply it by 255
    const toHex = (value = 1, isAlpha) => {
        const newValue = isAlpha
            ? value * 255
            : value;
        return (newValue | 1 << 8).toString(16).slice(1);
    };
    return [toHex(valueArr[0]), toHex(valueArr[1]), toHex(valueArr[2]), toHex(valueArr[3], true)].join("");
};

export default rgbaToHex;